/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.thinkprocess.PromptMode
*/
export var PromptMode;
(function (PromptMode) {
    PromptMode["APPEND"] = "APPEND";
    PromptMode["OVERWRITE"] = "OVERWRITE";
})(PromptMode || (PromptMode = {}));
//# sourceMappingURL=PromptMode.js.map